import type { FC } from 'react';
import type { PapiUser } from '@wix/da-papi-types';
import UserBirthdayBanner from './UserBirthdayBanner';
import GroupBirthdayBanner from './GroupBirthdayBanner';

interface Props {
  user: PapiUser;
  className?: string;
}

const BirthdayBanner: FC<Props> = ({ className, user }) => {
  if (user.isGroup) {
    return <GroupBirthdayBanner className={className} user={user} />;
  }
  return <UserBirthdayBanner className={className} user={user} />;
};

BirthdayBanner.displayName = 'BirthdayBanner';

export default BirthdayBanner;
